.root {
  list-style: none;
  margin: 0;
  padding: 0;
  outline: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
}

.content {
  display: flex;
  align-items: center;
  gap: var(--aura-space-2);
  border-radius: var(--aura-radius-lg);
  cursor: pointer;
  user-select: none;
  color: var(--aura-color-global-text-secondary);
  background: transparent;
  transition:
    background var(--aura-motion-duration-fast)
      var(--aura-motion-easing-standard),
    color var(--aura-motion-duration-fast) var(--aura-motion-easing-standard),
    box-shadow var(--aura-motion-duration-fast)
      var(--aura-motion-easing-standard);
  outline: none;
}

.sizeSmall {
  padding: calc(var(--aura-space-1) + 0.125rem) var(--aura-space-2);
}

.sizeMedium {
  padding: var(--aura-space-2) var(--aura-space-3);
}

.sizeLarge {
  padding: var(--aura-space-3) var(--aura-space-4);
}

.content:not(.disabled):hover {
  background: var(
    --tree-view-hover-bg,
    color-mix(in srgb, var(--aura-color-glass-surface) 35%, transparent)
  );
  color: var(--aura-color-global-text-primary);
}

.glass {
  background: color-mix(
    in srgb,
    var(--aura-color-glass-surface) 40%,
    transparent
  );
  border: 1px solid
    color-mix(in srgb, var(--aura-color-glass-border) 80%, transparent);
}

.glass:not(.disabled):hover {
  background: color-mix(
    in srgb,
    var(--aura-color-glass-surface) 60%,
    transparent
  );
}

.selected {
  background: var(--tree-view-selected-bg, var(--aura-color-highlight));
  color: var(--tree-view-color, var(--aura-color-global-text-primary));
  font-weight: var(--aura-font-weight-medium);
}

.focused {
  outline: 1px dashed
    var(--tree-view-color, var(--aura-color-global-border-strong));
}

.content:focus-visible {
  outline: none;
  box-shadow: var(
    --glass-elev-treeitem-focus,
    0 0 0 2px
      var(
        --glass-treeitem-focus-inner,
        color-mix(in srgb, var(--glass-gray-500) 45%, transparent)
      ),
    0 0 0 6px
      var(
        --glass-treeitem-focus-outer,
        color-mix(in srgb, hsl(var(--glass-color-primary)) 28%, transparent)
      )
  );
}

.disabled {
  cursor: default;
  opacity: 0.55;
  pointer-events: none;
}

.icon {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: var(--aura-space-1);
  color: inherit;
  flex-shrink: 0;
}

.toggleIcon {
  cursor: pointer;
}

.label {
  flex: 1;
  margin-left: var(--aura-space-1);
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.children {
  list-style: none;
  margin: 0;
  padding: 0 0 0 var(--aura-space-4);
  overflow: hidden;
  transform-origin: top;
}
